/**
 * Get employer notifications using Edge Function
 * Fetches fetch-type notifications from notification_queue for employer portal on login
 * Returns notifications and marks them as sent
 */

import { supabase } from '../supabaseClient';
import { NotificationsResponse } from '../../types/notifications';
import { ApiResponse } from '../../types/api';
import { handleEdgeFunctionError } from '../../utils/edgeFunctionUtils';

export async function getEmployerNotifications(): Promise<ApiResponse<NotificationsResponse>> {
  try {
    const { data, error } = await supabase.functions.invoke('get-employer-notifications', {
      body: {},
    });

    if (error) {
      console.error('[Edge Function Error] getEmployerNotifications:', error);
      const extractedError = await handleEdgeFunctionError(error);
      return { data: null, error: extractedError };
    }

    // The edge function returns { success: true, data: { notifications: [...], count: number } }
    if (data?.success && data?.data) {
      return { data: data.data, error: null };
    }

    // Handle case where success is false
    if (data?.success === false) {
      return { data: null, error: data?.error || 'Failed to fetch notifications' };
    }

    return { data: data?.data || null, error: data?.error || null };
  } catch (err) {
    console.error('[Edge Function Exception] getEmployerNotifications:', err);
    return { data: null, error: err };
  }
}

